<div class="cms-page">
  <p-toast></p-toast>
  <span class="page-focus-trap" tabindex="-1" aria-hidden="true"></span>
  <div class="page-header">
    <div class="page-header__top">
      <h1 class="page-title">News</h1>
      <p-button label="Add News" icon="pi pi-plus" (onClick)="onAddNews()" />
    </div>
    <div class="page-header__filters">
      <p-select-button
        [options]="labelOptions()"
        [ngModel]="displayedSelection()"
        (ngModelChange)="onLabelFilterChange($event)"
        optionLabel="label"
        optionValue="value"
        [multiple]="true"
        size="small"
      />
    </div>
  </div>
  <div
    class="page-body"
    cdkDropList
    cdkDropListOrientation="mixed"
    [cdkDropListData]="filteredNews()"
    (cdkDropListDropped)="onDrop($event)"
  >
    @for (item of filteredNews(); track item._cardId) {
      <div class="page-card-item" cdkDrag [cdkDragData]="item">
        <lib-cms-card
          [service]="item"
          [labelOptions]="newsLabels()"
          [singleLabel]="true"
          (serviceChange)="onNewsChange(item._cardId, $event)"
          (deleteService)="onDeleteNews(item._cardId)"
        />
      </div>
    } @empty {
      <p class="page-empty">No news match the selected filters.</p>
    }
  </div>
  <div class="page-footer">
    <p-button label="Publish" [disabled]="hasInvalidCards()" (onClick)="onPublish()" />
  </div>
</div>
